import { render, staticRenderFns } from "./AppointmentQuestionnaire.vue?vue&type=template&id=30d35a74&"
import script from "./AppointmentQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./AppointmentQuestionnaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports